import dynamic from "next/dynamic";
import Script from "next/script";
import { CSSProperties, FC } from "react";
import { useTheme } from "styled-components";
import {
  getAdInfo,
  AdServices,
} from "./adsConfigs";
import FixedAdSlot from "./AdsByStyle/FixedAdSlot";
import LeaderBoardAdSlot from "./AdsByStyle/LeaderBoardAdSlot";

export interface IAdsBillBoardNewProviderProps {
  adName: any;
  removePositionCenter?: boolean;
  width?: string;
  className?: string;
  style?: CSSProperties;
  isFixed?: boolean
}


const AdsBillBoardNewProvider: FC<IAdsBillBoardNewProviderProps> = ({
  adName,
  className = "",
  style,
  removePositionCenter,
  isFixed = true
}) => {
  const { device, enable3rdParty } = useTheme();
  const {
    adDetails: {
      sizes: adSizes,
      adUnit,
      id,
      "data-aa-adunit": data_aa_adunit,
      isVideo,
      disableInitialLoad,
    },
  } = getAdInfo({
    device: device as "mobile" | "desktop",
    adName,
    forceService: "google",
    isFixed
  });

  if (!enable3rdParty) return null;
  if (!adUnit) return null;

  const adSlotProps = {
    data_aa_adunit,
    removePositionCenter,
    adUnit,
    adName,
    adSizes,
    id,
    style,
    className,
    isVideo,
    disableInitialLoad,
    isFixed
  };

  function renderAdSlot() {
    const AdSlotPerServiceFactory: { [key in AdServices]: JSX.Element } = {
      google: !isVideo && isFixed ? <FixedAdSlot {...adSlotProps} /> : <LeaderBoardAdSlot {...adSlotProps} />,
    };
    return AdSlotPerServiceFactory["google"];
  }

  return (
    <>
      <Script
        key="google-ads-gpt-doubleclick"
        id="google-ads-gpt-doubleclick"
        src="https://securepubads.g.doubleclick.net/tag/js/gpt.js"
        strategy="lazyOnload"
        defer
        onError={(err) => {
          console.error("Google script loading error => ", err);
        }}
      />
      {renderAdSlot()}
    </>
  );
};

export default AdsBillBoardNewProvider;